import { render, staticRenderFns } from "./BaseValueTag.vue?vue&type=template&id=2e91f142&scoped=true"
import script from "./BaseValueTag.vue?vue&type=script&lang=js"
export * from "./BaseValueTag.vue?vue&type=script&lang=js"
import style0 from "./BaseValueTag.vue?vue&type=style&index=0&id=2e91f142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e91f142",
  null
  
)

export default component.exports